import { ReactComponent as CalendarIcon } from "./../../../../../asset/icons/cal.svg";
import { ReactComponent as UserIcon } from "./../../../../../asset/icons/userIcon.svg";
import moment from "moment-jalaali";
import { useTranslation } from "react-i18next";

export default function Group({ data, selectedGroups, setSelectedGroups }) {
    const { t } = useTranslation();

    const checkBoxHandle = () => {
        if (!selectedGroups.includes(data.id)) {
            setSelectedGroups([...selectedGroups, data.id]);
        } else {
            setSelectedGroups(
                selectedGroups.filter((item) => item !== data.id)
            );
        }
    };

    return (
        <div className="table-row" onClick={checkBoxHandle}>
            <div>
                <div
                    className={
                        selectedGroups.includes(data.id) ? "selected" : ""
                    }
                >
                    <div></div>
                </div>
            </div>
            <div>
                <div></div>
                <div>
                    <div>
                        {t("Organizational.CustomerClub.Groups.Level.Group")}
                    </div>
                    <div>{data.name}</div>
                </div>
            </div>
            <div>
                <UserIcon />
                {data.members_count}
            </div>
            <div>
                <CalendarIcon />
                {moment(data.apdate_at).format("jYYYY/jMM/jDD")}
            </div>
        </div>
    );
}
